<template>
  <div class="regionalMapManagement-page">
    <div class="all-content-container">
      <div class="content-title-container">
        <h5 @click="quanguo"><i class="el-icon-caret-left"></i>返回全国</h5>
        <el-button type="primary" @click="_seve">保存</el-button>
      </div>
      <div class="content-container">
        <div class="configList" v-if="c_index != null">
          <div class="configLi" v-for="(item, index) in configList" :key="index">
            <img @click="changePeng(item)" :src="item.image" alt="" />
          </div>
        </div>
        <draggable class="list-group" v-model="dataList" :options="{ draggable: '.dragList' }" :move="getdata"
          @update="datadragEnd">
          <div :class="c_index == index ? 'dragList idedit' : 'dragList'" :span="6" v-for="(item, index) in dataList"
            :key="index">
            <img @click="banck(item.id)" v-if="item.isGreenHouse == 1" class="dragImg" :src="item.image" alt="" />
            <div v-if="item.isGreenHouse == 1" class="cellText">
              {{ item.name }}
            </div>
            <i @click="_edit(index)" v-if="item.isGreenHouse == 1" class="el-icon-edit editConfig"></i>
            <div class="warning" v-if="item.isGreenHouse == 1 && item.ind < item.alarmData.length">
              <warning :arry="item.alarmData"></warning>
              <!-- <div
                class="warninground"
                :style="{'background':item.alarmData[item.ind].colorType}"
              >
                {{
                  item.alarmData[item.ind] && item.alarmData[item.ind].alarmType
                }}
              </div> -->
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import warning from "./warning";
import Sortable from "sortablejs";
export default {
  name: "regionalMapManagement",
  data() {
    return {
      dataList: [],
      oldList: [],
      configList: [],
      c_index: null,
      isEdit: false,
      id: "",
      ti: 0
    };
  },
  components: {
    draggable,
    warning
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      localStorage.setItem("id", this.$route.query.id);
    } else {
      this.id = localStorage.getItem("id");
    }

    this.getGreenHouseList(this.id);
    this.getConfigModelList();
  },
  mounted() {
    this.$forceUpdate();
    this._timer()
  },
  methods: {
    _timer() {
      let dataList = this.dataList;
      setInterval(() => {
        for (let i of dataList) {
          if (this.ti < i.alarmData, length) {
            i.ind = this.ti
          } else {
            i.ind = 0
            if (this._reset() == 0) {
              this.ti = 0
            }
          }
        }
        this.ti = this.ti + 1
      }, 1000);
    },
    _reset() {
      let dataList = this.dataList;
      let ind = 0
      for (let i of dataList) {
        if (i.ind != 0) {
          ind = 1
        }
      }
      return ind
    },
    _edit(index) {
      this.c_index = index;
      this.isEdit = true;
    },
    changePeng(item) {
      let dataList = this.dataList;
      this.dataList[this.c_index].image = item.image;
      this.dataList[this.c_index].groupModelId = item.id;
      this.c_index = null;
    },
    _seve() {
      let dataList = this.dataList;
      let arr = [];
      for (let i of dataList) {
        let obj = {
          groupModelId: i.groupModelId,
          id: i.id,
          name: i.name,
          isGreenHouse: i.isGreenHouse,
          positionNum: 0,
        };
        arr.push(obj);
      }
      this.$api.system.saveGreenHouse({ greenHouses: arr }).then((res) => {
        if (res.code == 200) {
          this.$message({ type: "success", message: res.msg });
          this.getGreenHouseList(this.id);
        }
      });
    },
    getdata(data) {
      // console.log(data)
      // this.dataList=this.oldList
    },
    datadragEnd(evt) {
      // console.log('datadragEnd方法');
      console.log("拖动前的索引 :" + evt.oldIndex);
      console.log("拖动后的索引 :" + evt.newIndex);
    },
    //查询区域下所有的大棚
    getConfigModelList() {
      this.$api.system.getConfigModelList().then((res) => {
        if (res.code == 200) {
          this.configList = res.data;
        }
      });
    },
    //查询区域下所有的大棚
    getGreenHouseList(id) {
      this.$api.system.getGreenHouseList(id).then((res) => {
        if (res.code == 200) {
          let items = res.data;
          for (let index = 0; index < items.length; index++) {
            if (items[index] != null) {
              items[index].ind = 0;
            }
            if (items[index].alarmData == null) {
              items[index].alarmData = []
            }
          }
          this.dataList = items;
        }
      });
    },
    banck(id) {
      this.$router.push({
        name: "greenhouseManagement",
        query: {
          id: id,
        },
      });
    },
    quanguo() {
      this.$router.push({
        name: "dataAnalysisManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/regionalMapManagement.scss";

.content-container {
  cursor: pointer;
}
</style>